module.exports = __webpack_public_path__ + "static/media/venuscasino.5bf79c19.png";